import config from '@plone/volto/registry';
import cx from 'classnames';
import Mask from './Mask';
import './styles.scss';
import React from 'react';

const View = (props) => {
  // - `data` holds the values entered in the block edit form.
  // - `className` holds the CSS class names injected into this block
  //   by Volto's `styleClassNameExtenders`.
  // - `style` holds the CSS properties injected into this block
  //   by Volto's `Block Style Wrapper`.
  const { data, className, style } = props;

  const Image = config.getComponent('Image').component;
  const image = data.preview_image?.[0];
  // Use the image's description for alt text; fall back to title.
  // Empty string only if neither is set (genuinely decorative context).
  const altText = image?.description || image?.title || '';

  return (
    <div
      className={cx('block', 'clipped-image-container', className)}
      style={style}
    >
      {image && (
        <Image
          item={image}
          imageField={image.image_field}
          alt={altText}
          loading="lazy"
          responsive={true}
        />
      )}
      <Mask />
    </div>
  );
};

export default View;
